import { useAppSelector } from '../../../redux/hook'
import NoOrganizationAccess from '../../Miscellaneous/NoOrganizationAccess'
import RegistryToolOnlyPage from '../../Miscellaneous/RegistryToolOnlyPage'
import UnAuthenticatedLayout from '../UnAuthenticatedLayout'
import RoutesComponent from './RoutesComponent'

/**
 * Content region rendered below the top navbar. Shows the no-organization
 * message for an authenticated "orphan" user (UBQ-5740), the Registry Tool page
 * for a Vendor Manufacturer (UBQ-5579), otherwise the normal routed application.
 */
const MainContent: React.FC = () => {
    const hasNoOrganizations = useAppSelector(
        (state) => state.org.hasNoOrganizations,
    )
    const registryToolOnly = useAppSelector(
        (state) => state.org.registryToolOnly,
    )

    if (hasNoOrganizations) {
        return <NoOrganizationAccess />
    }
    /* Until the org's answer arrives every route shows Home, which makes no backend call, so nothing the vendor
       would be refused on is loaded while waiting. */
    if (registryToolOnly === true) {
        return (
            <UnAuthenticatedLayout>
                <RegistryToolOnlyPage />
            </UnAuthenticatedLayout>
        )
    }
    return <RoutesComponent />
}

export default MainContent
